import React from 'react';
import PropTypes from 'prop-types';
import { CheckboxRadioGroup, CheckboxRadio } from '../CheckboxRadio';
import classNames from 'classnames';

/* eslint-disable react/prop-types */
const BootstrapCheckboxRadioButtons = (props) => {
  const {
    name,
    checkedValues,
    answerOptions,
    onChange,
    type,
    className,
    renderLabel,
  } = props;

  const classes = classNames('checkboxRadioButton', className);

  const renderAnswerOptions = () => {
    return answerOptions.map((option, index) => {
      const customClasses = option.customClasses || '';
      const inputClasses = classNames(customClasses, {
        checkboxRadioButton__option: true,
        btn: true,
        'checkboxRadioButton__option--checked': Array.isArray(checkedValues)
          ? checkedValues.indexOf(option.value) >= 0
          : checkedValues === option.value,
      });

      const label = renderLabel ? (
        renderLabel(option)
      ) : (
        <span className="checkboxRadioButton__option__label">
          {option.label}
        </span>
      );

      return (
        <label className={inputClasses} key={`${name}-${index}`}>
          <CheckboxRadio value={option.value} />
          {label}
          { option?.subtext && <span className="checkboxRadioButton__answerSubtext">{option.subtext}</span> }
          { option?.tooltip && <span className="checkboxRadioButton__option__tooltip">{option.tooltip}</span> }
          { option?.customTooltip && <span className="checkboxRadioButton__option__tooltip isCustomTooltip">{option.customTooltip}</span>}
        </label>
      );
    });
  };

  return (
    <CheckboxRadioGroup
      name={name}
      className={classes}
      checkboxDepth={2}
      onChange={onChange}
      type={type}
      value={checkedValues}
    >
      {renderAnswerOptions()}
    </CheckboxRadioGroup>
  );
};

const AnswerOptionShape = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.any,
  tooltip: PropTypes.any,
  subtext: PropTypes.any
});
BootstrapCheckboxRadioButtons.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
  checkedValues: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.any),
  ]),
  answerOptions: PropTypes.oneOfType([
    AnswerOptionShape,
    PropTypes.arrayOf(AnswerOptionShape),
  ]).isRequired,
};

export default BootstrapCheckboxRadioButtons;
